export default {
  async fetch({ dispatch, commit }) {
    commit("SET_LOADING", true);
    try {
      await dispatch("setCerts");
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async setCerts({ commit, state, rootGetters }, params = {}) {
    const { filter } = params;
    const size = rootGetters["application/getPageSize"];
    const { page } = state.paginator;
    const { field: sortBy, order: orderBy } = state.sort;

    try {
      const certs = await this.$services.cert.fetch({ size, page, sortBy, orderBy, filter });
      commit("SET_CERTS", certs);
      commit("SET_PAGINATOR", { page: certs.page, size: certs.size, total: certs.total });
      commit("SET_PAGINATOR_LOADING_PAGE", null);
    } catch (error) {
      throw new Error(error);
    }
  },

  async setCertsList({ commit, rootGetters }, params = {}) {
    const { filter } = params;

    try {
      const certs = await this.$services.cert.fetchList({
        filter,
        cancelToken: rootGetters["application/getCancelToken"]?.token,
      });
      commit("SET_CERTS_LIST", certs.collection);
    } catch (error) {
      throw new Error(error);
    }
  },

  updatePage({ commit }, page) {
    commit("SET_PAGINATOR_LOADING_PAGE", page);
    commit("SET_PAGINATOR_PAGE", page);
  },

  changeSort({ commit }, { field, order }) {
    commit("SET_SORT", { field, order });
  },

  async changeSizeTable({ commit, dispatch }, { size }) {
    await dispatch("application/savePageSize", size, { root: true });
    commit("SET_PAGINATOR_PAGE", 0);
    commit("SET_PAGINATOR_LOADING_PAGE", 0);
  },

  async addCert({ commit }, savedCert) {
    try {
      const cert = await this.$services.cert.create(savedCert);
      commit("ADD_CERT", cert);
      this.$feedback.ok("feedback.create.cert.ok");
    } catch (error) {
      const { error: prefix, message } = error.response.data;
      this.$feedback.error(`${prefix}${message}`);
    }
  },

  async deleteCert({ commit }, id) {
    try {
      await this.$services.cert.remove(id);
      commit("DELETE_CERT", id);
      this.$feedback.ok("feedback.delete.cert.ok");
    } catch (error) {
      this.$feedback.error("feedback.delete.cert.error");
    }
  },
};
